import React, { Component } from 'react'
import {FaWheelchair} from 'react-icons/fa'

class WheelChairPicker extends Component {

    render(){
        const {wheelChairRequired, onChange, disabled} = this.props
        return(
            <div className="wheel-chair-block">
                <input
                    type="checkbox"
                    id="wheelChair"
                    name="wheelChair"
                    value="wheelChair"
                    onChange={onChange}
                    checked={wheelChairRequired}
                    disabled={disabled}
                />
                    <label htmlFor="wheelChair">Necesito una silla de ruedas <FaWheelchair/> </label>
            </div>
        )
    }
}

export default WheelChairPicker
